import { combineReducers } from '@reduxjs/toolkit';

import userReducer from '@/store/user/reducers';
import investorReducer from '@/store/investor/reducers';
import entitiesReducer from '@/store/entities/reducers';
import adminReducer from '@/store/admin/reducers';

export const rootReducer = combineReducers({
  user: userReducer,
  investor: investorReducer,
  entities: entitiesReducer,
  admin: adminReducer
});
